var map = {
	"./IMG_20250421_234839.jpg": 1463,
	"./IMG_20250421_234914.png": 3981,
	"./Roof1.jpg": 4481,
	"./Roof2.jpg": 3610,
	"./Roof3.jpg": 8918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4854;